import { useEffect, useState, Fragment } from "react";
import { MapPin, Link } from "lucide-react";

const concertColor = [
  "#ce84a8",
  "#efd462",
  "#e28c86",
  "#9a83bb",
  "#98d2cf",
  "#f8b163"
];

const concertColorLight = [
  "#ceaaba",
  "#f9e2b4",
  "#e5aca5",
  "#bbabd4",
  "#c4e4e1",
  "#fbc786"
];

const getRandomColor = (i) => {
  return concertColor[i];
};

export default function Concerts({ t, lang }) {

  const [concerts, setConcerts] = useState([]);
  const [loading, setLoading] = useState(true);

  const formatDateTime = (date, date_end) => {

    const locale = lang === "fr" ? "fr-FR" : "en-US";

    const start = new Date(date);
    const end = date_end ? new Date(date_end) : null;

    const startDay = start.getDate();
    const startMonth = start.toLocaleDateString(locale, { month: "long" });
    const startYear = start.getFullYear();

    // Si pas de date_end
    if (!end) {
      return `${startDay} ${startMonth} ${startYear}`;
    }

    const endDay = end.getDate();
    const endMonth = end.toLocaleDateString(locale, { month: "long" });
    const endYear = end.getFullYear();

    // Même mois + même année
    if (startMonth === endMonth && startYear === endYear) {
      return `${startDay} – ${endDay} ${endMonth} ${startYear}`;
    }

    // Mois différents
    if (startYear === endYear) {
      return `${startDay} ${startMonth} – ${endDay} ${endMonth} ${startYear}`;
    }

    // Années différentes
    return `${startDay} ${startMonth} ${startYear} – ${endDay} ${endMonth} ${endYear}`;
  };


  useEffect(() => {
    fetch("/api/admin/concerts/concerts.php")
      .then(res => res.json())
      .then(data => {
        setConcerts(data.upcoming);
        setLoading(false);
      })
      .catch(err => {
        console.error("Erreur chargement concerts", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <section className="py-5 text-center">
        <p>Chargement des concerts…</p>
      </section>
    );
  }

  return (
    <section id="concerts">
        <div className="row concerts-grid" style={{rowGap: '4rem'}}>
        {concerts.map((p, i) => (
          <div
            key={i}
            className="col-12 col-md-6 col-lg-4 concert-col d-flex justify-content-center"
          >
            <div
              className="concert-card h-100"
              style={{ backgroundColor: "transparent" }}
            >
              <div className="card-body d-flex flex-column h-100">

                {/* CONTENU HAUT */}
                <div>
                  <h5
                    className="card-title mb-2"
                    style={{
                      fontFamily: "pangram-sans-semiBold",
                      fontSize: "1.6rem",
                    }}
                  >
                    {formatDateTime(p.date, p.date_end).toUpperCase()}
                  </h5>

                  <h3
                    style={{
                      fontFamily: "pangram-sans-medium",
                      fontSize: "1rem",
                      marginBottom: '2rem'
                    }}
                  >
                    <MapPin size={16} style={{ marginBottom: "3px", marginRight: "3px" }} />
                    {p.loc.toUpperCase()}
                  </h3>
                </div>

                {/* CONTENU BAS */}
                <div className="mb-4">
                  <h3
                    style={{
                      color: "black",
                      fontFamily: "pangram-sans-bold",
                      fontSize: "2.5rem",
                      marginBottom: "1rem"
                    }}
                  >
                    {p.title.toUpperCase()}
                  </h3>

                  <h4
                    style={{
                      color: "black",
                      fontFamily: "pangram-sans-regular",
                      fontSize: "1.4rem"
                    }}
                  >
                    {p.desc}
                  </h4>
                </div>

                {/* BOUTON */}
                {p.link && (
                  <div className="mt-auto">
                    <button
                      className="btn bg-black"
                      style={{
                        padding: '10px 20px',
                        fontFamily: 'pangram-sans-medium',
                        fontSize:'0.9rem',
                        borderRadius: "20px",
                        color: "rgba(255,255,255,0.8)"
                      }}
                      onClick={() => window.open(p.link, "_blank")}
                    >
                      {t("learn_more")} <Link size={16} />
                    </button>
                  </div>
                )}

              </div>
            </div>
          </div>
        ))}

      </div>
    </section>
  );
}